module.exports = __webpack_public_path__ + "img/fondecyt_logo.2411af52.png";